const playButtons = document.querySelectorAll('.textAndMedia-playButton');

if( playButtons.length ){
  playButtons.forEach( (button) => {
    button.addEventListener('click', (e) => {
      // console.log(e);
      const videoCover = e.target.parentElement;
      const iframe = videoCover.previousElementSibling;
      if( iframe && iframe.nodeName === 'IFRAME' ){
        play_iframe_video(iframe);
        videoCover.classList.add('is-hidden');
      }
    });
  } );
}


function play_iframe_video(iframe){
  const iframe_src = iframe.getAttribute('src');
  const autoplay_string = iframe_src.indexOf('autoplay');

  if (autoplay_string >= 0) {
    iframe.setAttribute('src', iframe_src.replace('autoplay=0', 'autoplay=1'));

  } else {

    if (iframe_src.indexOf('?') >= 0) {
      iframe.setAttribute('src', iframe_src + '&autoplay=1');

    } else {
      iframe.setAttribute('src', iframe_src + '?autoplay=1');
    }
  }

}